"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspendedCompsSym = exports.AppMaterializerSymbol = exports.MaterializedStoreSymbol = exports.StateRefsStoreSymbol = exports.ExportsStoreSymbol = exports.StructureAPI = exports.CompActionsSym = exports.Comps = exports.Structure = exports.StylesStoreSymbol = exports.Props = void 0;
exports.Props = Symbol('Props');
exports.StylesStoreSymbol = Symbol('StylesStore');
exports.Structure = Symbol('Structure');
exports.Comps = Symbol('Comps');
exports.CompActionsSym = Symbol('CompActions');
exports.StructureAPI = Symbol('StructureAPI');
exports.ExportsStoreSymbol = Symbol('Exports');
exports.StateRefsStoreSymbol = Symbol('StateRefs');
exports.MaterializedStoreSymbol = Symbol('MaterializedStore');
exports.AppMaterializerSymbol = Symbol('AppMaterializerSymbol');
exports.SuspendedCompsSym = Symbol('SuspendedComps');
//# sourceMappingURL=stores.js.map